import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

type ChartDataPoint = { date: string; totalAmount: number };

export default function Chart({ data }: { data: ChartDataPoint[] }) {
  // Format the y-axis values (e.g., 200k, 400k)
  const formatYAxis = (value: number) => {
    if (value === 0) return "0";
    return `${value / 1000}k`;
  };

  // Always render chart axes/grid, even if data is empty
  const isEmpty = Array.isArray(data) && data.length === 0;
  let chartData = data;
  if (isEmpty) {
    // Generate last 7 days with totalAmount 0
    const days = Array.from({ length: 7 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - (6 - i));
      return {
        date: d.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        totalAmount: 0,
      };
    });
    chartData = days;
  }
  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer className={"mt-4 -ml-6"} width="110%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
        >
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tickMargin={10}
            fontSize={12}
            stroke="#888888"
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={formatYAxis}
            fontSize={12}
            stroke="#888888"
            tickMargin={5}
            label={{
              value: "Total Amount",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle", fill: "#888888", fontSize: 14 },
            }}
          />
          {/* Always render Bar, even if all values are 0 */}
          <Bar
            dataKey="totalAmount"
            fill="#312e81"
            radius={[20, 20, 0, 0]}
            barSize={10}
            className="fill-indigo-950"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
